// Token de búsqueda para los valores que el indexador guarda en MAYÚSCULAS.
//
// El servidor indexa DNI y número de caso con `normalizeAlphaNum`
// (functions/src/searchIndexHelpers.js): quita diacríticos, pasa a mayúsculas y
// elimina todo lo que no sea alfanumérico. Los nombres, en cambio, van con
// `normalizeText`, en minúsculas. El buscador de la lista Cofidis solo generaba
// la forma en minúsculas, así que buscar un DNI o un NIE no encontraba nunca
// nada y la pantalla lo mostraba como «no existe el caso» — que es justo lo que
// empuja a crear un duplicado.
//
// Vive en su propio fichero para poder comprobarlo contra el indexador de
// verdad en cofidisSearchTokens.test.js: si alguien cambia uno de los dos
// normalizadores, el test lo dice.
export const SEARCH_PREFIX_MIN = 3;
export const SEARCH_PREFIX_MAX = 10;

export const buildAlphaNumSearchToken = (tag, value) => {
  const normalized = String(value === null || value === undefined ? '' : value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  if (normalized.length < SEARCH_PREFIX_MIN) {
    return null;
  }
  return `${tag}:${normalized.slice(0, Math.min(normalized.length, SEARCH_PREFIX_MAX))}`;
};
